module.exports = __webpack_public_path__ + "0aea7dd88975a870f7e00ffcb3035bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/team/Leadership_Curtis_0.jpg
// module id = 418
// module chunks = 0